<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>

		<a-form layout="inline" style="margin-bottom: 16px;">
			<a-form-item label="法律法规名称">
				<a-input v-model="filterData.keywords"  placeholder="请输入法律法规名称/ID"/>
			</a-form-item>
			<!-- <a-form-item label="标准编号">
				<a-input v-model="filterData.standardCode" />
			</a-form-item>
			<a-form-item label="执行状态">
				<a-select style="width: 200px" v-model="filterData.implementationStatus" class="mr12"
					placeholder="请选择执行状态" show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item> -->
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<!-- <a-button class="mr12" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12">导入</a-button> -->
				<a-button v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('LAWSREGULATIONS_ADD')" @click="toAdd" type="primary">新建法律法规</a-button>
			</a-form-item>
		</a-form>

		<!-- <div class="cate">
			<a-radio-group v-model="filterData.tagId" button-style="solid" @change="changeTab">
				<a-radio-button value="">全部</a-radio-button>
				<a-radio-button v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
				</a-radio-button>
			</a-radio-group>
		</div> -->



		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<!-- 执行状态 -->
			<!-- ACTIVE-现行有效 PENDING-即将实施 OBSOLETE-已废止 -->
			<!-- <template slot="implementationStatusRender" slot-scope="text, record">
				<a-tag color="green" v-if="record.implementationStatus == 'ACTIVE'">
					现行有效
				</a-tag>
				<a-tag color="#afa" v-else-if="record.implementationStatus == 'PENDING'">
					即将实施
				</a-tag>
				<a-tag color="#898989" v-else-if="record.implementationStatus == 'OBSOLETE'">
					已废止
				</a-tag>
				<a-tag v-else></a-tag>
			</template> -->
			<!-- 发布状态 1 2-->
			<template slot="standardStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.regulationStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.regulationStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.regulationStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<!-- 编辑，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span v-if="hasPermission('LAWSREGULATIONS_EDIT')"><a-button  type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link" v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('LAWSREGULATIONS_DEL')">删除</a-button>
					</a-popconfirm>
				</div>
			</template>

		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<!-- :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" -->
			<a-form-model ref="formRef" :model="editModel" :rules="rules">
				<!-- 	<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="标准编号" prop="standardCode">
							<a-input v-model="editModel.standardCode" placeholder="请输入标准标号" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="标准分类" prop="tagId">
							<a-select v-model="editModel.tagId" class="mr12" placeholder="请选择执行状态" show-search
								option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of tags" :key="index" :value="item.tagId">
									{{ item.tagName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row> -->

				<!-- 第二行：标准名称 通栏 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item prop="regulationName">
							<span slot="label"> 法律法规名称</span>
							<a-input v-model="editModel.regulationName" placeholder="请输入法律法规名称" />
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第三行：颁发部门 输入框+添加按钮 + 标签列表 todo -->
				<!-- <a-row>
					<a-col :span="24">
						<a-form-model-item label="颁发部门" prop="deptText">

							<div style="display: flex;">
								<a-input v-model="deptText" placeholder="请添加颁发部门" />
								<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addDept">+
									新增</a-button>
							</div>

							<div ref="dragContainer" style="width: 100%;">
								<div class="size_item" v-for="(item,idx) of deptList" :key="idx">
									<span class="left">{{ item }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer"
										@click="deleteDept(idx)" />
								</div>
							</div>


						</a-form-model-item>
					</a-col>
				</a-row> -->

				<!-- 第四行：实施日期 + 状态 -->
				<!-- 	<a-row :gutter="20">
					<a-col :span="12">
						<a-form-model-item label="实施日期" prop="implementationDate">
							<a-date-picker v-model="editModel.implementationDate" format="YYYY-MM-DD"
								valueFormat="YYYY-MM-DD" placeholder="请选择日期" style="width: 100%;" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="状态" prop="implementationStatus">
							<a-select v-model="editModel.implementationStatus" placeholder="请选择状态">
								<a-select-option value="ACTIVE">现行有效</a-select-option>
								<a-select-option value="PENDING">即将实施</a-select-option>
								<a-select-option value="OBSOLETE">已废止</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row> -->
				<!-- 适用范围 textarea 字数限制 -->
				<!-- 	<a-row>
					<a-col :span="24">
						<a-form-model-item label="适用范围" prop="scopeOfApplication">
							<a-textarea v-model="editModel.scopeOfApplication" :maxlength="500" show-count rows="4"
								placeholder="请输入适用范围" />
						</a-form-model-item>
					</a-col>
				</a-row> -->
				<!-- 标准说明 -->
				<!-- 	<a-row>
					<a-col :span="24">
						<a-form-model-item label="标准说明" prop="standardDescription">
							<a-textarea v-model="editModel.standardDescription" rows="4" placeholder="请输入标准说明" />
						</a-form-model-item>
					</a-col>
				</a-row> -->


				<!-- 第三行：颁发部门 输入框+添加按钮 + 标签列表 todo -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item
						:validateStatus="regulationClauseError ? 'error' : ''"
						:help="regulationClauseError ? '请添加法规条款' : ''">
							<span slot="label"> <span style="color:#f5222d;font-size: 14px;">* </span>法规条款</span>
							<div style="display: flex;">
								<a-input v-model="mainText" placeholder="请输入法规条款" />
								<a-button style="width: 100px;margin-left: 20px;" type="primary" @click="addMain" :disabled="mainList.length >= 3">+
									新增条款</a-button>
							</div>
							<div ref="dragContainerMain" class="clause-list" style="width: 100%;">
								<div class="size_item" v-for="(item,idx) of mainList" :key="item._sortKey || idx" :data-key="item._sortKey">
									<span class="left">{{ item.title }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer"
										@click="deletemain(idx)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 自定义内容 -->
				<!-- 富文本 -->
				<!-- 	<a-row>
					<a-col :span="24">
						<a-form-model-item label="自定义内容" prop="customContent">
							<quill-editor v-model="editModel.customContent" ref="myQuillEditor"
								:options="editorOption"></quill-editor>
						</a-form-model-item>
					</a-col>
				</a-row> -->

				<!--  --><a-row>
					<a-col :span="24">
						<a-form-model-item
						:validateStatus="standardDocError ? 'error' : ''"
						:help="standardDocError ? '请上传标准文件' : ''">
						<span slot="label"> <span style="color:#f5222d;font-size: 14px;">* </span>标准文件</span>
							<div style="display: flex;align-items: center;">
								<div style="display: flex;align-items: center;">
									<div v-if="editModel.standardDocument">
									{{editModel.standardDocument}}
								</div>
								</div>
								<div class="again_upload_box ml12">
									<input type="file" accept=".pdf" @change="handleUploadThumbnail" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">
										{{ editModel.standardDocument ? "重新上传" : "选择上传文件" }}
									</div>
								</div>
							</div>
							<div>只能上传PDF格式文件，文件不能超过10M</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!--  -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="regulationStatus">
							<!-- 改用 v-model 双向绑定，移除 :checked -->
							<a-switch v-model="editModel.regulationStatus" @change="handleSwitch" />
							<!-- 可选：加文字提示 -->
							<span style="margin-left:10px">{{ editModel.regulationStatus ? '启用' : '禁用' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 	<a-row>
					<a-col :span="24">
						<a-form-model-item label="废止日期" prop="obsolescenceDate">
							<a-date-picker v-model="editModel.obsolescenceDate" format="YYYY-MM-DD"
								valueFormat="YYYY-MM-DD" placeholder="请选择日期" style="width: 100%;" />
						</a-form-model-item>
					</a-col>
				</a-row> -->
				<!-- 排序 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="排序" prop="sort">
							<a-input v-model.number="editModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>

			</a-form-model>
		</a-modal>


		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-input v-model.number="tipsModel.bottomContent" placeholder="内容" /></div>
		</a-modal>

	</div>
</template>

<script>
	import Sortable from 'sortablejs';
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		// getTagCategoriesApi,
		// importExecutionStandardApi, // 导入
		getRegulationsListApi, //  执行标准列表
		getRegulationDetailApi, //  执行标准详情
		saveRegulationApi, //  执行标准新增/编辑
		deleteRegulationApi, //    执行标准删除
		updateRegulationStatusApi, //  执行标准 修改状态
		updateRegulationSortApi, //  修改排序
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				commodityStatusList: [{
						label: "现行有效",
						value: 'ACTIVE',
					},
					{
						label: "即将实施",
						value: 'PENDING',
					},
					{
						label: "已废止",
						value: 'OBSOLETE',
					},
				],
				columns: [{
						title: 'ID',
						dataIndex: 'regulationCode',
						key: 'regulationCode',
					},
					// {
					// 	title: '标准编号',
					// 	dataIndex: 'standardCode',
					// 	key: 'standardCode',
					// },
					{
						title: '法规名称',
						dataIndex: 'regulationName',
						key: 'regulationName',
					},
					// {
					// 	title: '分类',
					// 	dataIndex: 'tagName',
					// 	key: 'tagName',
					// },
					// {
					// 	title: '实施日期',
					// 	dataIndex: 'implementationDate',
					// 	key: 'implementationDate',
					// },
					// {
					// 	title: '状态',
					// 	dataIndex: 'implementationStatus',
					// 	key: 'implementationStatus',
					// 	scopedSlots: {
					// 		customRender: 'implementationStatusRender'
					// 	},
					// },
					{
						title: '发布状态',
						dataIndex: 'regulationStatus',
						key: 'regulationStatus',
						scopedSlots: {
							customRender: 'standardStatusRender'
						},
					},
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						scopedSlots: {
							customRender: 'indexSortender'
						},
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'STANDAR',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					regulationName: '',
					regulationClause: '',
					standardDocument: "",
					sort: null,
					regulationStatus: false,
					onOk: () => {},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					// standardCode: "",
					// implementationStatus: undefined,
					lang: "CH",
					// tagId: undefined
				},
				tags: [],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
				standardDocError: false,
				regulationClauseError: false,
				uploading: false,
				rules: {
					regulationName: [{ required: true, message: '请输入法律法规名称', trigger: 'blur' }],
				},

			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('lawsRegulations_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
				this.filterData.lang = 'CH';
			}
			this.getData(1)
			this.getTagsLabel()
			this.initDragBrand2()
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('lawsRegulations_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			toDownload(data) {
				this.$downLoadFile(data, '标准文件');
			},
			// 切换发布状态（带确认提示）
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					// 切换为 启用
					content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
				} else {
					// 切换为 禁用
					content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						// 确认后执行的操作
						// record.standardStatus = checked ? 1 : 0; // 接口需要数字，存回数字
						// 这里可以调用接口更新状态
						// TODO
						this.updateStatusApi(record.regulationId)
						console.log('发布状态已更新为：', record.regulationStatus);
					},
					onCancel: () => {
						// 取消时，保持开关原来的状态不变
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(regulationId) {
				updateRegulationStatusApi({
						regulationId: regulationId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"修改成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			// 保存排序（输入框回车/失焦触发）
			handleSaveSort(record) {
				// 排序号为空不提交
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				// 调用你已有的排序接口
				updateRegulationSortApi({
					regulationId: record.regulationId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},

			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push(this.deptText);
				this.deptText = '';
			},
			initDragBrand2() {
				const el = this.$refs.dragContainerMain
				if (!el) return
				if (el._sortableInstance) el._sortableInstance.destroy()
				el._sortableInstance = Sortable.create(el, {
					animation: 150, // 流畅动画
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						// 有 _sortKey 时按 DOM data-key 顺序重排，避免 index key 导致的顺序错乱
						if (this.mainList.length > 0 && this.mainList[0]._sortKey !== undefined) {
							const domOrder = Array.from(el.children).map(child => child.dataset.key).filter(Boolean);
							if (domOrder.length === this.mainList.length) {
								const reordered = domOrder.map(k =>
									this.mainList.find(item => String(item._sortKey) === k)
								).filter(Boolean);
								if (reordered.length === this.mainList.length) {
									this.mainList.splice(0, this.mainList.length, ...reordered);
								}
							}
						} else {
							const {
								oldIndex,
								newIndex
							} = evt
							// 数组顺序同步（核心！）
							const moveItem = this.mainList.splice(oldIndex, 1)[0]
							this.mainList.splice(newIndex, 0, moveItem)
						}
					},
				})
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push({
					title: this.mainText,
					_sortKey: Date.now() + Math.random()
				});
				this.mainText = '';
				this.regulationClauseError = false;
			},
			getTagsLabel() {
				// getTagCategoriesApi({
				// 	tagTypeCategory: 'EXECUTION_STANDARD'
				// }).then((res) => {
				// 	if (res.resultStatus) {
				// 		this.tags = res.resultData[0].tags

				// 	} else {}

				// })


			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				// v-model 已经自动更新 editModel.regulationStatus，这里只做额外逻辑
				console.log('新状态：', checked);
				// 如果不需要额外处理，这个方法甚至可以直接删掉，@change 都不用写
				//  this.editModel.regulationStatus = checked;
			},


			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						standardCode: "",
						lang: "CH",
						implementationStatus: undefined,
						tagId: undefined
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getRegulationsListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						lang: this.filterData.lang,
						keywords: this.filterData.keywords,
						// standardCode: this.filterData.standardCode,
						// tagId: this.filterData.tagId,
						// implementationStatus: this.filterData.implementationStatus,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				if (this.$refs.formRef) {
					this.$refs.formRef.clearValidate();
				}
				this.editModel = {
					flag: true,
					title: "新建法律法规",
					regulationId: '',
					executionStandardCode: '',
					standardCode: '',
					tagId: '',
					tagName: '',
					lang: '',
					standardName: '',
					issuingAuthority: '',
					implementationStatus: '',
					standardStatus: false,
					sort: null,
					scopeOfApplication: '',
					standardDescription: '',
					otherStand: '',
					physicochemicalIndicators: '',
					customContent: '',
					standardDocument: '',
					standardId: '',
					implementationDate: null,
					createTime: '',

					onOk: this.sureEdit,
				};
				this.mainList = [];
				this.mainText = "";
				this.deptList = [];
				this.deptText = "";
				this.standardDocError = false;
				this.regulationClauseError = false;
				this.$nextTick(() => {
					this.initDragBrand2();
				});
			},
			toEdit(data) {
				this.standardDocError = false;
				this.regulationClauseError = false;
				if (this.$refs.formRef) {
					this.$refs.formRef.clearValidate();
				}
				getRegulationDetailApi({
						regulationId: data.regulationId,
					})
					.then((res) => {
						if (res.resultStatus) {
							console.log(res.resultData, '看看返回的结果')
							const result = res.resultData;

							if (result.regulationClause) {
								const arr = JSON.parse(result.regulationClause)
								this.mainList = arr.map(item => ({ ...item, _sortKey: Date.now() + Math.random() }))
							}


							this.editModel = {
								"flag": true,
								"title": "编辑法律法规",
								regulationName: result.regulationName,
								regulationClause: result.regulationClause,
								standardDocument: result.standardDocument,
								regulationStatus: result.regulationStatus,
								sort: result.sort,
								regulationId: result.regulationId ?? '',
								onOk: this.sureEdit,
							};
							this.$nextTick(() => {
								this.initDragBrand2();
							});
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			confirm() {

			},
			sureScript(data) {
				console.log(data, '看看这个值是什么')
			},
			// 话术编辑
			scriptEdit() {
				this.tipsModel = {
					flag: true,
					title: "执行标准页面话术编辑",
					bottomTitle: "",
					bottomContent: "",
					onOk: this.sureScript,
				};
			},
			sureEdit(data) {
				this.standardDocError = false;
				this.regulationClauseError = false;

				let hasCustomError = false;
				if (!this.mainList.length) { this.regulationClauseError = true; hasCustomError = true; }
				if (!this.editModel.standardDocument) { this.standardDocError = true; hasCustomError = true; }

				this.$refs.formRef.validate((valid) => {
					if (!valid || hasCustomError) {
						return;
					}

				// let params ={
				// 		regulationId:this.editModel.regulationId,
				// 		"regulationName": this.editModel.regulationName, //法律法规名称
				// 		"regulationClause": this.mainList.join(';'), //法规条款
				// 		"standardDocument": this.editModel.standardDocument, //标准文件
				// 		"sort": this.editModel.sort,//排序
				// 		"regulationStatus": this.editModel.regulationStatus //发布状态
				// 	}
				// console.log(params,'看看这个参数')

				// return

				saveRegulationApi({
						regulationId: this.editModel.regulationId || 0,
						"regulationName": this.editModel.regulationName, //法律法规名称
						"regulationClause": JSON.stringify(this.mainList.map(({ _sortKey, ...rest }) => rest)),
						// "regulationClause": JSON.stringify(this.mainList.map(item => ({
						// 	title: item
						// }))), //法规条款
						"standardDocument": this.editModel.standardDocument, //标准文件
						"sort": this.editModel.sort, //排序
						"regulationStatus": this.editModel.regulationStatus //发布状态
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.executionStandardId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					});
				})
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				deleteRegulationApi({
						regulationId: record.regulationId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUploadThumbnail(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						if (file.size > 10 * 1024 * 1024) {
							this.$message.warning('文件大小不能超过 10MB');
							e.target.value = '';
							return;
						}
						this.uploading = true;
						ossUpload(file, '', 'pdf/').then((res) => {
							this.editModel.standardDocument = res.url;
							this.standardDocError = false;
						}).catch(err => {
							console.log("上传失败", err);
							this.$message.error('文件上传失败')
						}).finally(() => {
							this.uploading = false;
							e.target.value = ''; // 重置 input 值，避免下次选择同名文件不触发 change
					});
					}
				}
			},
		},
		};
	</script>
<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}

	.clause-list .size_item {
		min-height: 50px;
		height: auto;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.execution-form .ant-form-item {
		margin-bottom: 2px;
	}
	.execution-form .ant-form-item-label {
		padding-bottom: 0;
		line-height: 22px;
	}
	.execution-form .ant-form-item-control-wrapper {
		line-height: 22px;
	}
	.sort-ghost {
		opacity: 0.5;
		background: #c8ebfb !important;
	}
</style>

